import { company } from '../config/company';

export function StudioBrand() {
  return <span className="studio-brand__art"><img src="/odaro-studio-logo.svg" alt={company.serviceName} width={908} height={229} draggable={false} /></span>;
}
